import APIClient from '@/shared/http/clients/api'
import APIClientUpload from '@/shared/http/clients/apiupload'

const resourceName = 'regulationautobudget'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (id, data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)
const Search = (limit, index, data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const DownloadBudgets = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationauto/${id}/budgets`, config)
const Upload = (id, data = {}, config = {}) => APIClientUpload.post(`${APIRegAuto}/${resourceName}/regulationauto/${id}/budgets/upload`, data, config)

const RegulationAutoBudgetRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Update,
  Delete,
  Search,
  DownloadBudgets,
  Upload
}

export default RegulationAutoBudgetRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautobudget.js